import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import FileCopyTwoToneIcon from '@material-ui/icons/FileCopyTwoTone'
import EnhancedTableHead from './Components/EnhancedTableHead'
import { styles } from './style'

const EnhancedTable = ({
  classes,
  headers,
  rows,
  handleRequestSort,
  order,
  orderBy,
  resultPerPage,
  onChangePage,
  totalCount,
  onChangeRowsPerPage,
  page,
  overHeaderComponent,
  onClickRow,
}) => {
  const handleChangePage = (event, newPage) => {
    onChangePage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    onChangeRowsPerPage(event.target.value)
  }

  return (
    <div className={classes.root}>
      {rows && rows.length > 0 ? (
        <Paper className={classes.paper}>
          {overHeaderComponent}
          <TableContainer className={classes.tableWrapper}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={'small'}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                headCells={headers}
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
              />
              <TableBody>
                {rows.map((item, index) => {
                  return (
                    <TableRow
                      className={classNames({
                        [classes.row]: !index || index % 2 === 0,
                        [classes.highLight]: item.params.highLight,
                      })}
                      tabIndex={-1}
                      key={item.params.id}
                    >
                      {Object.keys(item.row).map((value, i) => {
                        const isClickable = !item.params.disableClick.includes(
                          value,
                        )
                        return (
                          <TableCell
                            key={i}
                            onClick={event =>
                              isClickable
                                ? onClickRow(event, item.params.id)
                                : null
                            }
                            className={classNames({
                              [classes.hover]: isClickable,
                            })}
                            align="center"
                          >
                            {item.row[value]}
                          </TableCell>
                        )
                      })}
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 200]}
            component="div"
            count={totalCount}
            rowsPerPage={resultPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      ) : (
        <div className={classes.noDataWrapper}>
          <div className={classes.wrapper}>
            <div className={classes.insideBlock}>
              <div>No Data</div>
              <FileCopyTwoToneIcon color="#8A96A0" />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(EnhancedTable)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/MasterSchedule/EnhancedTable/index.js